import y from "../../../../public/projects/rohan/projects/y.jpg";
import s from "../../../../public/projects/rohan/logo/s.png";
import evergreen from "../../../../public/projects/rohan/projects/ev.jpg"

// saroha
import overviewImagesaroha from "../../../../public/projects/rohan/saroha/overview/1.webp";
import bannerDesktopImagesaroha from "../../../../public/projects/rohan/saroha/banner/1.webp";
import bannerMobileImagesaroha from "../../../../public/projects/rohan/saroha/banner/2.webp";
import Locationsaroha from "../../../../public/projects/rohan/saroha/location/1.webp";
import Hightlightssaroha from "../../../../public/projects/rohan/saroha/highlights/1.webp";
import floorplan1saroha from "../../../../public/projects/rohan/saroha/floorplan/1.webp";
import floorplan2saroha from "../../../../public/projects/rohan/saroha/floorplan/2.webp";
import floorplan3saroha from "../../../../public/projects/rohan/saroha/floorplan/3.webp";
import floorplan4saroha from "../../../../public/projects/rohan/saroha/floorplan/4.webp";
import floorplan5saroha from "../../../../public/projects/rohan/saroha/floorplan/5.webp";
import locationiconsaroha from "../../../../public/projects/rohan/saroha/overview/l.png";
import caliconsaroha from "../../../../public/projects/rohan/saroha/overview/c.png";
import newlaunchiconsaroha from "../../../../public/projects/rohan/saroha/overview/n.png";
import gallery1saroha from "../../../../public/projects/rohan/saroha/gallery/1.webp";
import gallery2saroha from "../../../../public/projects/rohan/saroha/gallery/2.webp";
import gallery3saroha from "../../../../public/projects/rohan/saroha/gallery/3.webp";
import gallery4saroha from "../../../../public/projects/rohan/saroha/gallery/4.webp";
import gallery5saroha from "../../../../public/projects/rohan/saroha/gallery/5.webp";

// nidita
import overviewImagenidita from "../../../../public/projects/rohan/nidita/overview/1.webp";
import bannerDesktopImagenidita from "../../../../public/projects/rohan/nidita/banner/1.webp";
import bannerMobileImagenidita from "../../../../public/projects/rohan/nidita/banner/2.webp";
import Locationnidita from "../../../../public/projects/rohan/nidita/location/1.webp";
import Hightlightsnidita from "../../../../public/projects/rohan/nidita/highlights/1.webp";
import floorplan1nidita from "../../../../public/projects/rohan/nidita/floorplan/1.webp";
import floorplan2nidita from "../../../../public/projects/rohan/nidita/floorplan/2.webp";
import floorplan3nidita from "../../../../public/projects/rohan/nidita/floorplan/3.webp";
import floorplan4nidita from "../../../../public/projects/rohan/nidita/floorplan/4.webp";
import floorplan5nidita from "../../../../public/projects/rohan/nidita/floorplan/5.webp";
import locationiconnidita from "../../../../public/projects/rohan/nidita/overview/l.png";
import caliconnidita from "../../../../public/projects/rohan/nidita/overview/c.png";
import newlaunchiconnidita from "../../../../public/projects/rohan/nidita/overview/n.png";
import gallery1nidita from "../../../../public/projects/rohan/nidita/gallery/1.webp";
import gallery2nidita from "../../../../public/projects/rohan/nidita/gallery/2.webp";
import gallery3nidita from "../../../../public/projects/rohan/nidita/gallery/3.webp";
import gallery4nidita from "../../../../public/projects/rohan/nidita/gallery/4.webp";
import gallery5nidita from "../../../../public/projects/rohan/nidita/gallery/5.webp";

// projectthree
import overviewImageprojectthree from "../../../../public/projects/rohan/projectthree/overview/1.webp";
import bannerDesktopImageprojectthree from "../../../../public/projects/rohan/projectthree/banner/1.webp";
import bannerMobileImageprojectthree from "../../../../public/projects/rohan/projectthree/banner/2.webp";
import Locationprojectthree from "../../../../public/projects/rohan/projectthree/location/1.webp";
import Hightlightsprojectthree from "../../../../public/projects/rohan/projectthree/highlights/1.webp";
import floorplan1projectthree from "../../../../public/projects/rohan/projectthree/floorplan/1.webp";
import floorplan2projectthree from "../../../../public/projects/rohan/projectthree/floorplan/2.webp";
import floorplan3projectthree from "../../../../public/projects/rohan/projectthree/floorplan/3.webp";
import floorplan4projectthree from "../../../../public/projects/rohan/projectthree/floorplan/4.webp";
import floorplan5projectthree from "../../../../public/projects/rohan/projectthree/floorplan/5.webp";
import locationiconprojectthree from "../../../../public/projects/rohan/projectthree/overview/l.png";
import caliconprojectthree from "../../../../public/projects/rohan/projectthree/overview/c.png";
import newlaunchiconprojectthree from "../../../../public/projects/rohan/projectthree/overview/n.png";
import gallery1projectthree from "../../../../public/projects/rohan/projectthree/gallery/1.webp";
import gallery2projectthree from "../../../../public/projects/rohan/projectthree/gallery/2.webp";
import gallery3projectthree from "../../../../public/projects/rohan/projectthree/gallery/3.webp";
import gallery4projectthree from "../../../../public/projects/rohan/projectthree/gallery/4.webp";
import gallery5projectthree from "../../../../public/projects/rohan/projectthree/gallery/5.webp";

// projectfour
import overviewImageprojectfour from "../../../../public/projects/rohan/projectfour/overview/1.webp";
import bannerDesktopImageprojectfour from "../../../../public/projects/rohan/projectfour/banner/1.webp";
import bannerMobileImageprojectfour from "../../../../public/projects/rohan/projectfour/banner/2.webp";
import Locationprojectfour from "../../../../public/projects/rohan/projectfour/location/1.webp";
import Hightlightsprojectfour from "../../../../public/projects/rohan/projectfour/highlights/1.webp";
import floorplan1projectfour from "../../../../public/projects/rohan/projectfour/floorplan/1.webp";
import floorplan2projectfour from "../../../../public/projects/rohan/projectfour/floorplan/2.webp";
import floorplan3projectfour from "../../../../public/projects/rohan/projectfour/floorplan/3.webp";
import floorplan4projectfour from "../../../../public/projects/rohan/projectfour/floorplan/4.webp";
import floorplan5projectfour from "../../../../public/projects/rohan/projectfour/floorplan/5.webp";
import locationiconprojectfour from "../../../../public/projects/rohan/projectfour/overview/l.png";
import caliconprojectfour from "../../../../public/projects/rohan/projectfour/overview/c.png";
import newlaunchiconprojectfour from "../../../../public/projects/rohan/projectfour/overview/n.png";
import gallery1projectfour from "../../../../public/projects/rohan/projectfour/gallery/1.webp";
import gallery2projectfour from "../../../../public/projects/rohan/projectfour/gallery/2.webp";
import gallery3projectfour from "../../../../public/projects/rohan/projectfour/gallery/3.webp";
import gallery4projectfour from "../../../../public/projects/rohan/projectfour/gallery/4.webp";
import gallery5projectfour from "../../../../public/projects/rohan/projectfour/gallery/5.webp";

// projectfive
import overviewImageprojectfive from "../../../../public/projects/rohan/projectfive/overview/1.webp";
import bannerDesktopImageprojectfive from "../../../../public/projects/rohan/projectfive/banner/1.webp";
import bannerMobileImageprojectfive from "../../../../public/projects/rohan/projectfive/banner/2.webp";
import Locationprojectfive from "../../../../public/projects/rohan/projectfive/location/1.webp";
import Hightlightsprojectfive from "../../../../public/projects/rohan/projectfive/highlights/1.webp";
import floorplan1projectfive from "../../../../public/projects/rohan/projectfive/floorplan/1.webp";
import floorplan2projectfive from "../../../../public/projects/rohan/projectfive/floorplan/2.webp";
import floorplan3projectfive from "../../../../public/projects/rohan/projectfive/floorplan/3.webp";
import floorplan4projectfive from "../../../../public/projects/rohan/projectfive/floorplan/4.webp";
import floorplan5projectfive from "../../../../public/projects/rohan/projectfive/floorplan/5.webp";
import locationiconprojectfive from "../../../../public/projects/rohan/projectfive/overview/l.png";
import caliconprojectfive from "../../../../public/projects/rohan/projectfive/overview/c.png";
import newlaunchiconprojectfive from "../../../../public/projects/rohan/projectfive/overview/n.png";
import gallery1projectfive from "../../../../public/projects/rohan/projectfive/gallery/1.webp";
import gallery2projectfive from "../../../../public/projects/rohan/projectfive/gallery/2.webp";
import gallery3projectfive from "../../../../public/projects/rohan/projectfive/gallery/3.webp";
import gallery4projectfive from "../../../../public/projects/rohan/projectfive/gallery/4.webp";
import gallery5projectfive from "../../../../public/projects/rohan/projectfive/gallery/5.webp";

// projectsix
import overviewImageprojectsix from "../../../../public/projects/rohan/projectsix/overview/1.webp";
import bannerDesktopImageprojectsix from "../../../../public/projects/rohan/projectsix/banner/1.webp";
import bannerMobileImageprojectsix from "../../../../public/projects/rohan/projectsix/banner/2.webp";
import Locationprojectsix from "../../../../public/projects/rohan/projectsix/location/1.webp";
import Hightlightsprojectsix from "../../../../public/projects/rohan/projectsix/highlights/1.webp";
import floorplan1projectsix from "../../../../public/projects/rohan/projectsix/floorplan/1.webp";
import floorplan2projectsix from "../../../../public/projects/rohan/projectsix/floorplan/2.webp";
import floorplan3projectsix from "../../../../public/projects/rohan/projectsix/floorplan/3.webp";
import floorplan4projectsix from "../../../../public/projects/rohan/projectsix/floorplan/4.webp";
import floorplan5projectsix from "../../../../public/projects/rohan/projectsix/floorplan/5.webp";
import locationiconprojectsix from "../../../../public/projects/rohan/projectsix/overview/l.png";
import caliconprojectsix from "../../../../public/projects/rohan/projectsix/overview/c.png";
import newlaunchiconprojectsix from "../../../../public/projects/rohan/projectsix/overview/n.png";
import gallery1projectsix from "../../../../public/projects/rohan/projectsix/gallery/1.webp";
import gallery2projectsix from "../../../../public/projects/rohan/projectsix/gallery/2.webp";
import gallery3projectsix from "../../../../public/projects/rohan/projectsix/gallery/3.webp";
import gallery4projectsix from "../../../../public/projects/rohan/projectsix/gallery/4.webp";
import gallery5projectsix from "../../../../public/projects/rohan/projectsix/gallery/5.webp";

// projectseven
import overviewImageprojectseven from "../../../../public/projects/rohan/projectseven/overview/1.webp";
import bannerDesktopImageprojectseven from "../../../../public/projects/rohan/projectseven/banner/1.webp";
import bannerMobileImageprojectseven from "../../../../public/projects/rohan/projectseven/banner/2.webp";
import Locationprojectseven from "../../../../public/projects/rohan/projectseven/location/1.webp";
import Hightlightsprojectseven from "../../../../public/projects/rohan/projectseven/highlights/1.webp";
import floorplan1projectseven from "../../../../public/projects/rohan/projectseven/floorplan/1.webp";
import floorplan2projectseven from "../../../../public/projects/rohan/projectseven/floorplan/2.webp";
import floorplan3projectseven from "../../../../public/projects/rohan/projectseven/floorplan/3.webp";
import floorplan4projectseven from "../../../../public/projects/rohan/projectseven/floorplan/4.webp";
import floorplan5projectseven from "../../../../public/projects/rohan/projectseven/floorplan/5.webp";
import locationiconprojectseven from "../../../../public/projects/rohan/projectseven/overview/l.png";
import caliconprojectseven from "../../../../public/projects/rohan/projectseven/overview/c.png";
import newlaunchiconprojectseven from "../../../../public/projects/rohan/projectseven/overview/n.png";
import gallery1projectseven from "../../../../public/projects/rohan/projectseven/gallery/1.webp";
import gallery2projectseven from "../../../../public/projects/rohan/projectseven/gallery/2.webp";
import gallery3projectseven from "../../../../public/projects/rohan/projectseven/gallery/3.webp";
import gallery4projectseven from "../../../../public/projects/rohan/projectseven/gallery/4.webp";
import gallery5projectseven from "../../../../public/projects/rohan/projectseven/gallery/5.webp";

// projecteight
import overviewImageprojecteight from "../../../../public/projects/rohan/projecteight/overview/1.webp";
import bannerDesktopImageprojecteight from "../../../../public/projects/rohan/projecteight/banner/1.webp";
import bannerMobileImageprojecteight from "../../../../public/projects/rohan/projecteight/banner/2.webp";
import Locationprojecteight from "../../../../public/projects/rohan/projecteight/location/1.webp";
import Hightlightsprojecteight from "../../../../public/projects/rohan/projecteight/highlights/1.webp";
import floorplan1projecteight from "../../../../public/projects/rohan/projecteight/floorplan/1.webp";
import floorplan2projecteight from "../../../../public/projects/rohan/projecteight/floorplan/2.webp";
import floorplan3projecteight from "../../../../public/projects/rohan/projecteight/floorplan/3.webp";
import floorplan4projecteight from "../../../../public/projects/rohan/projecteight/floorplan/4.webp";
import floorplan5projecteight from "../../../../public/projects/rohan/projecteight/floorplan/5.webp";
import locationiconprojecteight from "../../../../public/projects/rohan/projecteight/overview/l.png";
import caliconprojecteight from "../../../../public/projects/rohan/projecteight/overview/c.png";
import newlaunchiconprojecteight from "../../../../public/projects/rohan/projecteight/overview/n.png";
import gallery1projecteight from "../../../../public/projects/rohan/projecteight/gallery/1.webp";
import gallery2projecteight from "../../../../public/projects/rohan/projecteight/gallery/2.webp";
import gallery3projecteight from "../../../../public/projects/rohan/projecteight/gallery/3.webp";
import gallery4projecteight from "../../../../public/projects/rohan/projecteight/gallery/4.webp";
import gallery5projecteight from "../../../../public/projects/rohan/projecteight/gallery/5.webp";

// projectnine
import overviewImageprojectnine from "../../../../public/projects/rohan/projectnine/overview/1.webp";
import bannerDesktopImageprojectnine from "../../../../public/projects/rohan/projectnine/banner/1.webp";
import bannerMobileImageprojectnine from "../../../../public/projects/rohan/projectnine/banner/2.webp";
import Locationprojectnine from "../../../../public/projects/rohan/projectnine/location/1.webp";
import Hightlightsprojectnine from "../../../../public/projects/rohan/projectnine/highlights/1.webp";
import floorplan1projectnine from "../../../../public/projects/rohan/projectnine/floorplan/1.webp";
import floorplan2projectnine from "../../../../public/projects/rohan/projectnine/floorplan/2.webp";
import floorplan3projectnine from "../../../../public/projects/rohan/projectnine/floorplan/3.webp";
import floorplan4projectnine from "../../../../public/projects/rohan/projectnine/floorplan/4.webp";
import floorplan5projectnine from "../../../../public/projects/rohan/projectnine/floorplan/5.webp";
import locationiconprojectnine from "../../../../public/projects/rohan/projectnine/overview/l.png";
import caliconprojectnine from "../../../../public/projects/rohan/projectnine/overview/c.png";
import newlaunchiconprojectnine from "../../../../public/projects/rohan/projectnine/overview/n.png";
import gallery1projectnine from "../../../../public/projects/rohan/projectnine/gallery/1.webp";
import gallery2projectnine from "../../../../public/projects/rohan/projectnine/gallery/2.webp";
import gallery3projectnine from "../../../../public/projects/rohan/projectnine/gallery/3.webp";
import gallery4projectnine from "../../../../public/projects/rohan/projectnine/gallery/4.webp";
import gallery5projectnine from "../../../../public/projects/rohan/projectnine/gallery/5.webp";

// projectten
import overviewImageprojectten from "../../../../public/projects/rohan/projectten/overview/1.webp";
import bannerDesktopImageprojectten from "../../../../public/projects/rohan/projectten/banner/1.webp";
import bannerMobileImageprojectten from "../../../../public/projects/rohan/projectten/banner/2.webp";
import Locationprojectten from "../../../../public/projects/rohan/projectten/location/1.webp";
import Hightlightsprojectten from "../../../../public/projects/rohan/projectten/highlights/1.webp";
import floorplan1projectten from "../../../../public/projects/rohan/projectten/floorplan/1.webp";
import floorplan2projectten from "../../../../public/projects/rohan/projectten/floorplan/2.webp";
import floorplan3projectten from "../../../../public/projects/rohan/projectten/floorplan/3.webp";
import floorplan4projectten from "../../../../public/projects/rohan/projectten/floorplan/4.webp";
import floorplan5projectten from "../../../../public/projects/rohan/projectten/floorplan/5.webp";
import locationiconprojectten from "../../../../public/projects/rohan/projectten/overview/l.png";
import caliconprojectten from "../../../../public/projects/rohan/projectten/overview/c.png";
import newlaunchiconprojectten from "../../../../public/projects/rohan/projectten/overview/n.png";
import gallery1projectten from "../../../../public/projects/rohan/projectten/gallery/1.webp";
import gallery2projectten from "../../../../public/projects/rohan/projectten/gallery/2.webp";
import gallery3projectten from "../../../../public/projects/rohan/projectten/gallery/3.webp";
import gallery4projectten from "../../../../public/projects/rohan/projectten/gallery/4.webp";
import gallery5projectten from "../../../../public/projects/rohan/projectten/gallery/5.webp";



export const developerrohan = {
  properties: [
    {
      name: "rohan The Trillion",
      image: bannerMobileImagesaroha,
      price: " 6.14 Crore Onwards",
      state: " Gurugram",
      developer: "rohan",
      location: "Sector 48, Gurugram",
      projectlocation: "Gurugram",
      bed: "3,4 BHK Apartments",
      size: "3000-3600 sq.ft.",
      url: `/rohan-trillion`,
      form: {
        source_id: 11,
        api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
        api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
        sub_source_id: 130,
        builder_id: `103`,
        project_id: `477`,
        subject: "rohan The Trillion",
        to_email: "jatin.rohilla@propertystation.in",
      }
    },
  ],
};
export const Headers = {
  logo: s,
  data: {
    experience: "2006",
  },
  about: `rohan, a 100% FDI funded real-estate developer, backed by rohan Holdings Pte. Ltd., Singapore, the real estate investing division of the AT Holdings group of companies. AT Capital, headquartered in Singapore, was established with the aim of capitalizing on global opportunities within both established and emerging sectors.`,
};


export const projectsrohan = {

  saroha: {
    bannerdata: {
      bannerDesktopImage: bannerDesktopImagesaroha,
      bannerMobileImage: bannerMobileImagesaroha,
      textOverlay: "",
      data: {
        title: "Rohan Saroha",
        subtitle: "Bhugaon, Pune",
        starting_price: "₹ 84 Lakh Onwards",
        payment_plan: "Flexible Payment Plans",
        rerano: "P52100076652",
        status: "New Launch"
      }
    },

    overview: {
      heading: "Rohan Saroha",
      description: [
        "Rohan Saroha in Bhugaon, Pune, is a premium residential project by Rohan Builders, offering a blend of luxury and nature. Spread across approximately 13 acres, the development comprises 5 towers with 15 floors each, housing 2, 3, and 4 BHK apartments. The project is RERA registered under ID P52100076652, ensuring transparency and compliance.",
        "Rohan Saroha project is strategically located in Bhugaon, offering excellent connectivity to key areas like Kothrud, Bavdhan, and Hinjewadi IT Park. The project is just a short drive from the Pune-Pune Expressway, making daily commuting convenient.",
        "The development is surrounded by hills and valleys, providing a serene living environment with natural light and ventilation. The project is part of a 100+ acre township, ensuring a well-planned community living experience.",
      ],
      keywordLinks: {
      },
      image: overviewImagesaroha,
      buttonLabel: "Enquire Now",
      stripdata: [
        {
          iconClass: locationiconsaroha,
          title: "₹ 84 Lakh Onwards",
          subtitle: "Starting Price",
        },
        {
          iconClass: caliconsaroha,
          title: "Flexible Plans",
          subtitle: "Payment Plan",
        },
        {
          iconClass: newlaunchiconsaroha,
          title: "New Launch",
          subtitle: "Status",
        },
      ],
    },

    pricing: {
      heading: "Pricing",
      table: [
        {
          type: "2 BHK",
          area: "836 - 1288 sq.ft.",
          price: "₹ 84.9 L - 1.2 Cr",
          eoiAmount: "Onwards",
        },
        {
          type: "3 BHK",
          area: "1075.97 - 1382 sq.ft.",
          price: "₹ 1.09 - 1.35 Cr",
          eoiAmount: "Onwards",
        },
        {
          type: "4 BHK",
          area: "1535.7 - 2023 sq.ft.",
          price: "₹ 1.63 - 1.99 Cr",
          eoiAmount: "Onwards",
        }
      ],
    },

    floor_plan: [
      {
        type: "2 BHK",
        area: "836 - 1288 sq.ft.",
        price: "₹ 84.9 L - 1.2 Cr",
        image: floorplan1saroha,
      },
      {
        type: "3 BHK",
        area: "1075.97 - 1382 sq.ft.",
        price: "₹ 1.09 - 1.35 Cr",
        image: floorplan2saroha,
      },
      {
        type: "4 BHK",
        area: "1535.7 - 2023 sq.ft.",
        price: "₹ 1.63 - 1.99 Cr",
        image: floorplan3saroha,
      }
    ],

    highlights: {
      images: Hightlightssaroha,
      tagline: "Highlights",
      features: [
        "Located in the midst of a 100+ acre township",
        "Surrounded by hills and valleys",
        "3-level Parking Space",
        "Luxury Amenities for all age groups",
        "Natural light and ventilation ensuring healthy environment",
        "Excellent connectivity to key areas of Pune"
      ],
    },

    location: {
      image: Locationsaroha,
      data: [
        {
          airport: {
            distance_time: "25.9 km",
            name: "Pune Intl Airport"
          },
          school: {
            distance_time: "3.4 km",
            name: "Ambrosia College"
          },
          railwayormetro: {
            distance_time: "14.7 km",
            name: "CSMN Station"
          },
          hospital: {
            distance_time: "5.1 km",
            name: "Chellaram Hospital"
          },
          mall: {
            distance_time: "12.9 km",
            name: "The Pavilion Mall"
          }
        }
      ]
    },

    gallery: {
      color: "#cd8c66",
      tagline: "Project Gallery",
      images: [
        { image: gallery1saroha },
        { image: gallery2saroha },
        { image: gallery3saroha },
        { image: gallery4saroha },
        { image: gallery5saroha },
      ],
    },

    whatsapp: {
      title: "Property Station",
      subTitle: "Happy to Help You!",
      greetingText: "Hi there! \nI'm interested in Rohan Saroha, Pune. Can you share more details?",
      ctaText: "Start Chat",
      whatsAppNumber: "7079429676",
      welcomeMessage:
        "Hi! I'm interested in Rohan Saroha, Pune. Kindly share more details.",
    },

    faq: [
      {
        question: "Who is the developer of Rohan Saroha?",
        answer: "The project is developed by Rohan Builders.",
      },
      {
        question: "What are the available apartment configurations?",
        answer: "Rohan Saroha offers 2 BHK, 3 BHK, and 4 BHK apartments.",
      },
      {
        question: "What is the size range of the apartments?",
        answer: "The apartments range from approximately 836 sq.ft. for 2 BHK units to 2023 sq.ft. for 4 BHK units.",
      },
      {
        question: "What is the possession timeline for the project?",
        answer: "The possession for Rohan Saroha is expected by September 2028.",
      },
      {
        question: "Is the project RERA registered?",
        answer: "Yes, Rohan Saroha is RERA registered with the ID P52100076652.",
      },
      {
        question: "What amenities are provided in the project?",
        answer: "Residents can enjoy amenities like a swimming pool, gymnasium, and yoga room.",
      },
      {
        question: "How many towers and floors are there in the project?",
        answer: "Rohan Saroha Phase 1 comprises 2 towers with configurations of G+15/16 floors.",
      },
      {
        question: "What are the nearby landmarks and facilities?",
        answer: "The project is close to Manas Lake (2.9 km), and Chandani Chowk (4.2 km).",
      },
      {
        question: "Are there eco-friendly features in the project?",
        answer: "Yes, the project includes features like rainwater harvesting and energy-efficient lighting.",
      },
      {
        question: "Is there parking available for residents?",
        answer: "Yes, Rohan Saroha provides ample parking space for residents.",
      }
    ],

    form_data: {
      api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
      api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
      source_id: 11,
      sub_source_id: 130,
      builder_id: `103`,
      project_id: `477`,
      subject: "Property Station enquiry - Rohan Saroha, Pune",
      to_email: "leads@puneproperty.com",
    },
  },
  nidita: {
    bannerdata: {
      bannerDesktopImage: bannerDesktopImagenidita,
      bannerMobileImage: bannerMobileImagenidita,
      textOverlay: "",
      data: {
        title: "Rohan Nidita",
        subtitle: "Hinjewadi, Pune",
        starting_price: "₹ 73.83 L - 1.41 Cr Onwards",
        payment_plan: "Flexible Payment Plans",
        rerano: "P52100050746",
        status: "Under Construction"
      }
    },

    overview: {
      heading: "Rohan Nidita",
      description: [
        "Rohan Nidita in Hinjewadi, Pune is a premium residential project by Rohan Builders, offering a perfect blend of modern living and investment potential in one of Pune's fastest-growing areas. The project features well-designed 2 BHK and 3 BHK apartments that maximize space, light, and ventilation.",
        "The development stands out with its eco-friendly features including rainwater harvesting, energy-saving lights, and waste management systems. The project is designed with a resort-inspired landscape featuring lush greenery and undulating terrain, creating a peaceful oasis in the bustling city.",
        "Rohan Nidita offers excellent connectivity to major IT parks, schools, and hospitals, with convenient access to the Mumbai-Pune Expressway and future metro stations. The project is developed by Rohan Builders, known for their quality construction and timely delivery.",
        "With its prime location, modern amenities, and thoughtful design, Rohan Nidita presents an excellent opportunity for both homebuyers and investors looking for premium residential spaces in Pune's thriving Hinjewadi area.",
      ],
      keywordLinks: {
      },
      image: overviewImagenidita,
      buttonLabel: "Enquire Now",
      stripdata: [
        {
          iconClass: locationiconnidita,
          title: "₹ 73.83 L - 1.41 Cr",
          subtitle: "Starting Price",
        },
        {
          iconClass: caliconnidita,
          title: "Flexible Plans",
          subtitle: "Payment Plan",
        },
        {
          iconClass: newlaunchiconnidita,
          title: "Under Construction",
          subtitle: "Status",
        },
      ],
    },

    pricing: {
      heading: "Pricing",
      table: [
        {
          type: "2 BHK",
          area: "645.62 - 984 sq.ft.",
          price: "₹ 73.83 L - 1.13 Cr",
          eoiAmount: "Onwards",
        },
        {
          type: "3 BHK",
          area: "973.06 - 1191 sq.ft.",
          price: "₹ 1.15 - 1.41 Cr",
          eoiAmount: "Onwards",
        },
      ],
    },

    floor_plan: [
      {
        type: "2 BHK",
        area: "645.62 - 984 sq.ft.",
        price: "₹ 73.83 L - 1.13 Cr",
        image: floorplan1nidita,
      },
      {
        type: "3 BHK",
        area: "973.06 - 1191 sq.ft.",
        price: "₹ 1.15 - 1.41 Cr",
        image: floorplan2nidita,
      }
    ],

    highlights: {
      images: Hightlightsnidita,
      tagline: "Highlights",
      features: [
        "70% of the area is open space",
        "No overlooking windows or balconies for enhanced privacy",
        "Sky Sports Club located 100 meters above ground",
        "Resort-inspired landscape with lush greenery and undulating terrain",
        "Eco-friendly features including rainwater harvesting",
        "Energy-saving lighting and waste management systems",
        "Well-connected location near IT parks and business hubs",
      ],
    },

    location: {
      image: Locationnidita,
      data: [
        {
          airport: {
            distance_time: "23 km",
            name: "Pune International Airport"
          },
          school: {
            distance_time: "1.4 km",
            name: "Genius English School"
          },
          railwayormetro: {
            distance_time: "10 km",
            name: "Kasarwadi Station"
          },
          hospital: {
            distance_time: "700 m",
            name: "LifeTree Hospital"
          },
          mall: {
            distance_time: "800 m",
            name: "Xion Mall"
          }
        }
      ]
    },

    gallery: {
      color: "#cd8c66",
      tagline: "Project Gallery",
      images: [
        { image: gallery1nidita },
        { image: gallery2nidita },
        { image: gallery3nidita },
        { image: gallery4nidita },
        { image: gallery5nidita },
      ],
    },

    whatsapp: {
      title: "Property Station",
      subTitle: "Happy to Help You!",
      greetingText: "Hi there! \nI'm interested in Rohan Nidita, Hinjewadi. Can you share more details?",
      ctaText: "Start Chat",
      whatsAppNumber: "7079429676",
      welcomeMessage:
        "Hi! I'm interested in Rohan Nidita, Hinjewadi. Kindly share more details.",
    },

    faq: [
      {
        question: "What types of apartments are available at Rohan Nidita Hinjewadi?",
        answer: "The project offers 2 and 3 BHK apartments with carpet areas ranging from 645 to 1191 sq.ft.",
      },
      {
        question: "What is the price range of flats in Rohan Nidita?",
        answer: "Prices start from ₹73.83 lakh for a 2 BHK and ₹1.15 crore for a 3 BHK.",
      },
      {
        question: "Is Rohan Nidita RERA approved?",
        answer: "Yes, the project is RERA approved with registration number P52100050746.",
      },
      {
        question: "What amenities are offered in Rohan Nidita?",
        answer: "Amenities include a gymnasium, swimming pool, kids' play areas, mini theatre, and clubhouse.",
      },
      {
        question: "How many towers and floors does the project have?",
        answer: "Rohan Nidita comprises 4 towers with 25 floors each and offers around 388 units.",
      },
      {
        question: "What is the construction status of Rohan Nidita?",
        answer: "The project is currently under construction.",
      },
      {
        question: "Who is the developer of Rohan Nidita?",
        answer: "Rohan Nidita is developed by Rohan Builders.",
      },
      {
        question: "What are the unique features of the project's design?",
        answer: "The project prioritizes privacy with private entranceways, no overlooking windows or balconies, and limited apartments per floor.",
      },
      {
        question: "What are some nearby landmarks and facilities?",
        answer: "Key landmarks include Hilton Garden Inn Pune Hinjawadi, Xion Mall, and Shivaji Chowk Metro Station. The nearest hospital is Wankhede Eye Hospital.",
      },
      {
        question: "Why should one consider investing in Rohan Nidita?",
        answer: "Rohan Nidita offers a blend of luxury, privacy, modern amenities, and a prime location near IT parks and essential infrastructure.",
      }
    ],


    form_data: {
      api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
      api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
      source_id: 11,
      sub_source_id: 130,
      builder_id: `103`,
      project_id: `477`,
      subject: "Property Station enquiry", // Add or update the subject here
      to_email: "leads@gurugram-property.com",
    },
  },
  projectthree: {
    bannerdata: {
      bannerDesktopImage: bannerDesktopImageprojectthree,
      bannerMobileImage: bannerMobileImageprojectthree,
      textOverlay: "",
      data: {
        title: "rohan The Trillion",
        subtitle: " Sector 48, Gurugram",
        starting_price: "₹ 6.14 Crore Onwards  ",
        payment_plan: "20:40:40",
        rerano: "GGM/911/643/2025/14",
        status: "New Launch"
      }
    },

    overview: {
      heading: "rohan The Trillion",
      description: [
        "rohan The Trillion in Gurgaon is a new luxury residential project that offers a stylish and comfortable lifestyle. This residential project is located in Sector 48, Golf Course Extension Road, this project is designed for people who want a modern home with top-class features. It is developed by rohan Developers, The Trillion brings a perfect mix of beautiful design, world-class amenities, and a prime location.",
        "The project offers spacious 3 BHK, 4 BHK apartments, and penthouses with smart layouts and premium interiors. Every home at rohan Trillion is made to give you more space, natural light, and a peaceful environment. High-quality materials, smart home features, and luxury fittings make each apartment truly special.",
        "Living at rohan Trillion Sector 48 Gurgaon means enjoying a lot of premium facilities. There is a modern clubhouse, swimming pool, gym, spa, private dining spaces, children’s play area, and beautiful green gardens. You also get 24x7 security, concierge services, and easy access to all daily needs.",
        "The location of rohan The Trillion is one of its biggest advantages. It is close to important offices, schools, hospitals, malls, and restaurants. Major roads like Golf Course Road, NH-8, and the Rapid Metro are nearby, making travel quick and easy.",
      ],
      keywordLinks: {
        "rohan": "/developers/rohan",
      },
      image: overviewImageprojectthree,
      buttonLabel: "Enquire Now",
      stripdata: [
        {
          iconClass: locationiconprojectthree,
          title: "₹ 6.14 Crore Onwards ",
          subtitle: "Starting Price",
        },
        {
          iconClass: caliconprojectthree,
          title: "20:40:40",
          subtitle: "Payment Plan",
        },
        {
          iconClass: newlaunchiconprojectthree,
          title: "New Launch ",
          subtitle: "Status",
        },
      ],
    },

    pricing: {
      heading: "Pricing",
      table: [
        {
          type: "3 BHK ",
          area: "3000 sq.ft.",
          price: "₹ 6.14 Cr",
          eoiAmount: "On Request",
        },
        {
          type: "4 BHK  ",
          area: "3600 sq.ft. ",
          price: "₹ 7.37 Cr",
          eoiAmount: "On Request",
        },
      ],
    },

    floor_plan: [
      {
        type: "3 BHK ",
        area: "3000 sq.ft.",
        price: "₹ 6.14 Cr",
        image: floorplan1projectthree,
      },
      {
        type: "4 BHK  ",
        area: "3600 sq.ft. ",
        price: "₹ 7.37 Cr",
        image: floorplan2projectthree,
      }
    ],

    highlights: {
      images: Hightlightsprojectthree,
      tagline: "Highlights",
      features: [
        "540 EXCLUSIVE Units. ",
        "Over 80% of green space. ",
        "Stilt + 45 Storey Towers. ",
        "VRV / VRF Air-Conditioning & Modular Kitche. ",
        "Basement Entrance Lobby with Green Atrium. ",
        "Two Car Parkings Per Unit. ",
        "Over 1 lakh sq. ft. of amenities space. ",
      ],
    },

    location: {
      image: Locationprojectthree,
      data: [
        {
          airport: {
            distance_time: "24 km",
            name: "IGI Airport"
          },
          school: {
            distance_time: "1 Km",
            name: "GD Goenka School"
          },
          railwayormetro: {
            distance_time: "6 Km",
            name: "Millennium City Centre Gurugram"
          },
          hospital: {
            distance_time: "1 Km",
            name: "Park Hospital"
          },
          mall: {
            distance_time: "7 Km",
            name: "Airia Mall"
          }
        }
      ]
    },

    gallery: {
      color: "#cd8c66",
      tagline: "Project Gallery",
      images: [
        { image: gallery1projectthree },
        { image: gallery2projectthree },
        { image: gallery3projectthree },
        { image: gallery4projectthree },
        { image: gallery5projectthree },
      ],
    },

    whatsapp: {
      title: "Property Station",
      subTitle: "Happy to Help You!",
      greetingText: "Hi there! \nHow can I help you?",
      ctaText: "Start Chat",
      whatsAppNumber: "7079429676",
      welcomeMessage:
        "Hi! I'm interested in rohan The Trillion, kindly share more details.",
    },

    faq: [
      {
        question: "Where is rohan The Trillion located?",
        answer: `rohan The Trillion is located in Sector 48, Gurgaon, providing excellent connectivity to major business hubs and city landmarks.`,
      },
      {
        question: "What types of homes are available at rohan The Trillion?",
        answer: `rohan The Trillion offers spacious 3 BHK and 4 BHK luxury apartments designed for premium living.`,
      },
      {
        question: "What is the size range of apartments in rohan The Trillion?",
        answer: `The 3 BHK apartments are approximately 2850 sq. ft., and the 4 BHK apartments are around 3600 sq. ft.`,
      },
      {
        question: "What is the price range for apartments at rohan The Trillion?",
        answer: `Prices start from ₹6.14 Crores onwards, depending on the unit size, floor, and view.`,
      },
      {
        question: "Is the project RERA registered?",
        answer: `Yes, rohan The Trillion is RERA registered.`,
      },
      {
        question: "What is the possession status of rohan The Trillion?",
        answer: `The project is newly launched.`,
      },
      {
        question: "What amenities are offered at rohan The Trillion?",
        answer: `Amenities include a grand clubhouse, swimming pool, gym, spa, kids’ play area, jogging track, and landscaped gardens.`,
      },
      {
        question: "Who is the developer of rohan The Trillion?",
        answer: `rohan The Trillion is developed by rohan Developers, one of India's most trusted and reputed real estate developers, known for quality and innovation.`,
      },
      {
        question: "Is rohan The Trillion a good investment in Gurgaon?",
        answer: `Yes, with its prime location, luxury features, and strong brand reputation, rohan The Trillion is considered an excellent investment option in Gurgaon.`,
      },
      {
        question: "How is the connectivity from rohan The Trillion?",
        answer: `The project enjoys superb connectivity via Golf Course Extension Road and NH-8, offering easy access to major business centers and important city locations.`,
      }
    ],


    form_data: {
      api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
      api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
      source_id: 11,
      sub_source_id: 130,
      builder_id: `103`,
      project_id: `477`,
      subject: "Property Station enquiry", // Add or update the subject here
      to_email: "leads@gurugram-property.com",
    },
  },
  projectfour: {
    bannerdata: {
      bannerDesktopImage: bannerDesktopImageprojectfour,
      bannerMobileImage: bannerMobileImageprojectfour,
      textOverlay: "",
      data: {
        title: "rohan The Trillion",
        subtitle: " Sector 48, Gurugram",
        starting_price: "₹ 6.14 Crore Onwards  ",
        payment_plan: "20:40:40",
        rerano: "GGM/911/643/2025/14",
        status: "New Launch"
      }
    },

    overview: {
      heading: "rohan The Trillion",
      description: [
        "rohan The Trillion in Gurgaon is a new luxury residential project that offers a stylish and comfortable lifestyle. This residential project is located in Sector 48, Golf Course Extension Road, this project is designed for people who want a modern home with top-class features. It is developed by rohan Developers, The Trillion brings a perfect mix of beautiful design, world-class amenities, and a prime location.",
        "The project offers spacious 3 BHK, 4 BHK apartments, and penthouses with smart layouts and premium interiors. Every home at rohan Trillion is made to give you more space, natural light, and a peaceful environment. High-quality materials, smart home features, and luxury fittings make each apartment truly special.",
        "Living at rohan Trillion Sector 48 Gurgaon means enjoying a lot of premium facilities. There is a modern clubhouse, swimming pool, gym, spa, private dining spaces, children’s play area, and beautiful green gardens. You also get 24x7 security, concierge services, and easy access to all daily needs.",
        "The location of rohan The Trillion is one of its biggest advantages. It is close to important offices, schools, hospitals, malls, and restaurants. Major roads like Golf Course Road, NH-8, and the Rapid Metro are nearby, making travel quick and easy.",
      ],
      keywordLinks: {
        "rohan": "/developers/rohan",
      },
      image: overviewImageprojectfour,
      buttonLabel: "Enquire Now",
      stripdata: [
        {
          iconClass: locationiconprojectfour,
          title: "₹ 6.14 Crore Onwards ",
          subtitle: "Starting Price",
        },
        {
          iconClass: caliconprojectfour,
          title: "20:40:40",
          subtitle: "Payment Plan",
        },
        {
          iconClass: newlaunchiconprojectfour,
          title: "New Launch ",
          subtitle: "Status",
        },
      ],
    },

    pricing: {
      heading: "Pricing",
      table: [
        {
          type: "3 BHK ",
          area: "3000 sq.ft.",
          price: "₹ 6.14 Cr",
          eoiAmount: "On Request",
        },
        {
          type: "4 BHK  ",
          area: "3600 sq.ft. ",
          price: "₹ 7.37 Cr",
          eoiAmount: "On Request",
        },
      ],
    },

    floor_plan: [
      {
        type: "3 BHK ",
        area: "3000 sq.ft.",
        price: "₹ 6.14 Cr",
        image: floorplan1projectfour,
      },
      {
        type: "4 BHK  ",
        area: "3600 sq.ft. ",
        price: "₹ 7.37 Cr",
        image: floorplan2projectfour,
      }
    ],

    highlights: {
      images: Hightlightsprojectfour,
      tagline: "Highlights",
      features: [
        "540 EXCLUSIVE Units. ",
        "Over 80% of green space. ",
        "Stilt + 45 Storey Towers. ",
        "VRV / VRF Air-Conditioning & Modular Kitche. ",
        "Basement Entrance Lobby with Green Atrium. ",
        "Two Car Parkings Per Unit. ",
        "Over 1 lakh sq. ft. of amenities space. ",
      ],
    },

    location: {
      image: Locationprojectfour,
      data: [
        {
          airport: {
            distance_time: "24 km",
            name: "IGI Airport"
          },
          school: {
            distance_time: "1 Km",
            name: "GD Goenka School"
          },
          railwayormetro: {
            distance_time: "6 Km",
            name: "Millennium City Centre Gurugram"
          },
          hospital: {
            distance_time: "1 Km",
            name: "Park Hospital"
          },
          mall: {
            distance_time: "7 Km",
            name: "Airia Mall"
          }
        }
      ]
    },

    gallery: {
      color: "#cd8c66",
      tagline: "Project Gallery",
      images: [
        { image: gallery1projectfour },
        { image: gallery2projectfour },
        { image: gallery3projectfour },
        { image: gallery4projectfour },
        { image: gallery5projectfour },
      ],
    },

    whatsapp: {
      title: "Property Station",
      subTitle: "Happy to Help You!",
      greetingText: "Hi there! \nHow can I help you?",
      ctaText: "Start Chat",
      whatsAppNumber: "7079429676",
      welcomeMessage:
        "Hi! I'm interested in rohan The Trillion, kindly share more details.",
    },

    faq: [
      {
        question: "Where is rohan The Trillion located?",
        answer: `rohan The Trillion is located in Sector 48, Gurgaon, providing excellent connectivity to major business hubs and city landmarks.`,
      },
      {
        question: "What types of homes are available at rohan The Trillion?",
        answer: `rohan The Trillion offers spacious 3 BHK and 4 BHK luxury apartments designed for premium living.`,
      },
      {
        question: "What is the size range of apartments in rohan The Trillion?",
        answer: `The 3 BHK apartments are approximately 2850 sq. ft., and the 4 BHK apartments are around 3600 sq. ft.`,
      },
      {
        question: "What is the price range for apartments at rohan The Trillion?",
        answer: `Prices start from ₹6.14 Crores onwards, depending on the unit size, floor, and view.`,
      },
      {
        question: "Is the project RERA registered?",
        answer: `Yes, rohan The Trillion is RERA registered.`,
      },
      {
        question: "What is the possession status of rohan The Trillion?",
        answer: `The project is newly launched.`,
      },
      {
        question: "What amenities are offered at rohan The Trillion?",
        answer: `Amenities include a grand clubhouse, swimming pool, gym, spa, kids’ play area, jogging track, and landscaped gardens.`,
      },
      {
        question: "Who is the developer of rohan The Trillion?",
        answer: `rohan The Trillion is developed by rohan Developers, one of India's most trusted and reputed real estate developers, known for quality and innovation.`,
      },
      {
        question: "Is rohan The Trillion a good investment in Gurgaon?",
        answer: `Yes, with its prime location, luxury features, and strong brand reputation, rohan The Trillion is considered an excellent investment option in Gurgaon.`,
      },
      {
        question: "How is the connectivity from rohan The Trillion?",
        answer: `The project enjoys superb connectivity via Golf Course Extension Road and NH-8, offering easy access to major business centers and important city locations.`,
      }
    ],


    form_data: {
      api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
      api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
      source_id: 11,
      sub_source_id: 130,
      builder_id: `103`,
      project_id: `477`,
      subject: "Property Station enquiry", // Add or update the subject here
      to_email: "leads@gurugram-property.com",
    },
  },
  projectfive: {
    bannerdata: {
      bannerDesktopImage: bannerDesktopImageprojectfive,
      bannerMobileImage: bannerMobileImageprojectfive,
      textOverlay: "",
      data: {
        title: "rohan The Trillion",
        subtitle: " Sector 48, Gurugram",
        starting_price: "₹ 6.14 Crore Onwards  ",
        payment_plan: "20:40:40",
        rerano: "GGM/911/643/2025/14",
        status: "New Launch"
      }
    },

    overview: {
      heading: "rohan The Trillion",
      description: [
        "rohan The Trillion in Gurgaon is a new luxury residential project that offers a stylish and comfortable lifestyle. This residential project is located in Sector 48, Golf Course Extension Road, this project is designed for people who want a modern home with top-class features. It is developed by rohan Developers, The Trillion brings a perfect mix of beautiful design, world-class amenities, and a prime location.",
        "The project offers spacious 3 BHK, 4 BHK apartments, and penthouses with smart layouts and premium interiors. Every home at rohan Trillion is made to give you more space, natural light, and a peaceful environment. High-quality materials, smart home features, and luxury fittings make each apartment truly special.",
        "Living at rohan Trillion Sector 48 Gurgaon means enjoying a lot of premium facilities. There is a modern clubhouse, swimming pool, gym, spa, private dining spaces, children’s play area, and beautiful green gardens. You also get 24x7 security, concierge services, and easy access to all daily needs.",
        "The location of rohan The Trillion is one of its biggest advantages. It is close to important offices, schools, hospitals, malls, and restaurants. Major roads like Golf Course Road, NH-8, and the Rapid Metro are nearby, making travel quick and easy.",
      ],
      keywordLinks: {
        "rohan": "/developers/rohan",
      },
      image: overviewImageprojectfive,
      buttonLabel: "Enquire Now",
      stripdata: [
        {
          iconClass: locationiconprojectfive,
          title: "₹ 6.14 Crore Onwards ",
          subtitle: "Starting Price",
        },
        {
          iconClass: caliconprojectfive,
          title: "20:40:40",
          subtitle: "Payment Plan",
        },
        {
          iconClass: newlaunchiconprojectfive,
          title: "New Launch ",
          subtitle: "Status",
        },
      ],
    },

    pricing: {
      heading: "Pricing",
      table: [
        {
          type: "3 BHK ",
          area: "3000 sq.ft.",
          price: "₹ 6.14 Cr",
          eoiAmount: "On Request",
        },
        {
          type: "4 BHK  ",
          area: "3600 sq.ft. ",
          price: "₹ 7.37 Cr",
          eoiAmount: "On Request",
        },
      ],
    },

    floor_plan: [
      {
        type: "3 BHK ",
        area: "3000 sq.ft.",
        price: "₹ 6.14 Cr",
        image: floorplan1projectfive,
      },
      {
        type: "4 BHK  ",
        area: "3600 sq.ft. ",
        price: "₹ 7.37 Cr",
        image: floorplan2projectfive,
      }
    ],

    highlights: {
      images: Hightlightsprojectfive,
      tagline: "Highlights",
      features: [
        "540 EXCLUSIVE Units. ",
        "Over 80% of green space. ",
        "Stilt + 45 Storey Towers. ",
        "VRV / VRF Air-Conditioning & Modular Kitche. ",
        "Basement Entrance Lobby with Green Atrium. ",
        "Two Car Parkings Per Unit. ",
        "Over 1 lakh sq. ft. of amenities space. ",
      ],
    },

    location: {
      image: Locationprojectfive,
      data: [
        {
          airport: {
            distance_time: "24 km",
            name: "IGI Airport"
          },
          school: {
            distance_time: "1 Km",
            name: "GD Goenka School"
          },
          railwayormetro: {
            distance_time: "6 Km",
            name: "Millennium City Centre Gurugram"
          },
          hospital: {
            distance_time: "1 Km",
            name: "Park Hospital"
          },
          mall: {
            distance_time: "7 Km",
            name: "Airia Mall"
          }
        }
      ]
    },

    gallery: {
      color: "#cd8c66",
      tagline: "Project Gallery",
      images: [
        { image: gallery1projectfive },
        { image: gallery2projectfive },
        { image: gallery3projectfive },
        { image: gallery4projectfive },
        { image: gallery5projectfive },
      ],
    },

    whatsapp: {
      title: "Property Station",
      subTitle: "Happy to Help You!",
      greetingText: "Hi there! \nHow can I help you?",
      ctaText: "Start Chat",
      whatsAppNumber: "7079429676",
      welcomeMessage:
        "Hi! I'm interested in rohan The Trillion, kindly share more details.",
    },

    faq: [
      {
        question: "Where is rohan The Trillion located?",
        answer: `rohan The Trillion is located in Sector 48, Gurgaon, providing excellent connectivity to major business hubs and city landmarks.`,
      },
      {
        question: "What types of homes are available at rohan The Trillion?",
        answer: `rohan The Trillion offers spacious 3 BHK and 4 BHK luxury apartments designed for premium living.`,
      },
      {
        question: "What is the size range of apartments in rohan The Trillion?",
        answer: `The 3 BHK apartments are approximately 2850 sq. ft., and the 4 BHK apartments are around 3600 sq. ft.`,
      },
      {
        question: "What is the price range for apartments at rohan The Trillion?",
        answer: `Prices start from ₹6.14 Crores onwards, depending on the unit size, floor, and view.`,
      },
      {
        question: "Is the project RERA registered?",
        answer: `Yes, rohan The Trillion is RERA registered.`,
      },
      {
        question: "What is the possession status of rohan The Trillion?",
        answer: `The project is newly launched.`,
      },
      {
        question: "What amenities are offered at rohan The Trillion?",
        answer: `Amenities include a grand clubhouse, swimming pool, gym, spa, kids’ play area, jogging track, and landscaped gardens.`,
      },
      {
        question: "Who is the developer of rohan The Trillion?",
        answer: `rohan The Trillion is developed by rohan Developers, one of India's most trusted and reputed real estate developers, known for quality and innovation.`,
      },
      {
        question: "Is rohan The Trillion a good investment in Gurgaon?",
        answer: `Yes, with its prime location, luxury features, and strong brand reputation, rohan The Trillion is considered an excellent investment option in Gurgaon.`,
      },
      {
        question: "How is the connectivity from rohan The Trillion?",
        answer: `The project enjoys superb connectivity via Golf Course Extension Road and NH-8, offering easy access to major business centers and important city locations.`,
      }
    ],


    form_data: {
      api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
      api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
      source_id: 11,
      sub_source_id: 130,
      builder_id: `103`,
      project_id: `477`,
      subject: "Property Station enquiry", // Add or update the subject here
      to_email: "leads@gurugram-property.com",
    },
  },
  projectsix: {
    bannerdata: {
      bannerDesktopImage: bannerDesktopImageprojectsix,
      bannerMobileImage: bannerMobileImageprojectsix,
      textOverlay: "",
      data: {
        title: "rohan The Trillion",
        subtitle: " Sector 48, Gurugram",
        starting_price: "₹ 6.14 Crore Onwards  ",
        payment_plan: "20:40:40",
        rerano: "GGM/911/643/2025/14",
        status: "New Launch"
      }
    },

    overview: {
      heading: "rohan The Trillion",
      description: [
        "rohan The Trillion in Gurgaon is a new luxury residential project that offers a stylish and comfortable lifestyle. This residential project is located in Sector 48, Golf Course Extension Road, this project is designed for people who want a modern home with top-class features. It is developed by rohan Developers, The Trillion brings a perfect mix of beautiful design, world-class amenities, and a prime location.",
        "The project offers spacious 3 BHK, 4 BHK apartments, and penthouses with smart layouts and premium interiors. Every home at rohan Trillion is made to give you more space, natural light, and a peaceful environment. High-quality materials, smart home features, and luxury fittings make each apartment truly special.",
        "Living at rohan Trillion Sector 48 Gurgaon means enjoying a lot of premium facilities. There is a modern clubhouse, swimming pool, gym, spa, private dining spaces, children’s play area, and beautiful green gardens. You also get 24x7 security, concierge services, and easy access to all daily needs.",
        "The location of rohan The Trillion is one of its biggest advantages. It is close to important offices, schools, hospitals, malls, and restaurants. Major roads like Golf Course Road, NH-8, and the Rapid Metro are nearby, making travel quick and easy.",
      ],
      keywordLinks: {
        "rohan": "/developers/rohan",
      },
      image: overviewImageprojectsix,
      buttonLabel: "Enquire Now",
      stripdata: [
        {
          iconClass: locationiconprojectsix,
          title: "₹ 6.14 Crore Onwards ",
          subtitle: "Starting Price",
        },
        {
          iconClass: caliconprojectsix,
          title: "20:40:40",
          subtitle: "Payment Plan",
        },
        {
          iconClass: newlaunchiconprojectsix,
          title: "New Launch ",
          subtitle: "Status",
        },
      ],
    },

    pricing: {
      heading: "Pricing",
      table: [
        {
          type: "3 BHK ",
          area: "3000 sq.ft.",
          price: "₹ 6.14 Cr",
          eoiAmount: "On Request",
        },
        {
          type: "4 BHK  ",
          area: "3600 sq.ft. ",
          price: "₹ 7.37 Cr",
          eoiAmount: "On Request",
        },
      ],
    },

    floor_plan: [
      {
        type: "3 BHK ",
        area: "3000 sq.ft.",
        price: "₹ 6.14 Cr",
        image: floorplan1projectsix,
      },
      {
        type: "4 BHK  ",
        area: "3600 sq.ft. ",
        price: "₹ 7.37 Cr",
        image: floorplan2projectsix,
      }
    ],

    highlights: {
      images: Hightlightsprojectsix,
      tagline: "Highlights",
      features: [
        "540 EXCLUSIVE Units. ",
        "Over 80% of green space. ",
        "Stilt + 45 Storey Towers. ",
        "VRV / VRF Air-Conditioning & Modular Kitche. ",
        "Basement Entrance Lobby with Green Atrium. ",
        "Two Car Parkings Per Unit. ",
        "Over 1 lakh sq. ft. of amenities space. ",
      ],
    },

    location: {
      image: Locationprojectsix,
      data: [
        {
          airport: {
            distance_time: "24 km",
            name: "IGI Airport"
          },
          school: {
            distance_time: "1 Km",
            name: "GD Goenka School"
          },
          railwayormetro: {
            distance_time: "6 Km",
            name: "Millennium City Centre Gurugram"
          },
          hospital: {
            distance_time: "1 Km",
            name: "Park Hospital"
          },
          mall: {
            distance_time: "7 Km",
            name: "Airia Mall"
          }
        }
      ]
    },

    gallery: {
      color: "#cd8c66",
      tagline: "Project Gallery",
      images: [
        { image: gallery1projectsix },
        { image: gallery2projectsix },
        { image: gallery3projectsix },
        { image: gallery4projectsix },
        { image: gallery5projectsix },
      ],
    },

    whatsapp: {
      title: "Property Station",
      subTitle: "Happy to Help You!",
      greetingText: "Hi there! \nHow can I help you?",
      ctaText: "Start Chat",
      whatsAppNumber: "7079429676",
      welcomeMessage:
        "Hi! I'm interested in rohan The Trillion, kindly share more details.",
    },

    faq: [
      {
        question: "Where is rohan The Trillion located?",
        answer: `rohan The Trillion is located in Sector 48, Gurgaon, providing excellent connectivity to major business hubs and city landmarks.`,
      },
      {
        question: "What types of homes are available at rohan The Trillion?",
        answer: `rohan The Trillion offers spacious 3 BHK and 4 BHK luxury apartments designed for premium living.`,
      },
      {
        question: "What is the size range of apartments in rohan The Trillion?",
        answer: `The 3 BHK apartments are approximately 2850 sq. ft., and the 4 BHK apartments are around 3600 sq. ft.`,
      },
      {
        question: "What is the price range for apartments at rohan The Trillion?",
        answer: `Prices start from ₹6.14 Crores onwards, depending on the unit size, floor, and view.`,
      },
      {
        question: "Is the project RERA registered?",
        answer: `Yes, rohan The Trillion is RERA registered.`,
      },
      {
        question: "What is the possession status of rohan The Trillion?",
        answer: `The project is newly launched.`,
      },
      {
        question: "What amenities are offered at rohan The Trillion?",
        answer: `Amenities include a grand clubhouse, swimming pool, gym, spa, kids’ play area, jogging track, and landscaped gardens.`,
      },
      {
        question: "Who is the developer of rohan The Trillion?",
        answer: `rohan The Trillion is developed by rohan Developers, one of India's most trusted and reputed real estate developers, known for quality and innovation.`,
      },
      {
        question: "Is rohan The Trillion a good investment in Gurgaon?",
        answer: `Yes, with its prime location, luxury features, and strong brand reputation, rohan The Trillion is considered an excellent investment option in Gurgaon.`,
      },
      {
        question: "How is the connectivity from rohan The Trillion?",
        answer: `The project enjoys superb connectivity via Golf Course Extension Road and NH-8, offering easy access to major business centers and important city locations.`,
      }
    ],


    form_data: {
      api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
      api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
      source_id: 11,
      sub_source_id: 130,
      builder_id: `103`,
      project_id: `477`,
      subject: "Property Station enquiry", // Add or update the subject here
      to_email: "leads@gurugram-property.com",
    },
  },
  projectseven: {
    bannerdata: {
      bannerDesktopImage: bannerDesktopImageprojectseven,
      bannerMobileImage: bannerMobileImageprojectseven,
      textOverlay: "",
      data: {
        title: "rohan The Trillion",
        subtitle: " Sector 48, Gurugram",
        starting_price: "₹ 6.14 Crore Onwards  ",
        payment_plan: "20:40:40",
        rerano: "GGM/911/643/2025/14",
        status: "New Launch"
      }
    },

    overview: {
      heading: "rohan The Trillion",
      description: [
        "rohan The Trillion in Gurgaon is a new luxury residential project that offers a stylish and comfortable lifestyle. This residential project is located in Sector 48, Golf Course Extension Road, this project is designed for people who want a modern home with top-class features. It is developed by rohan Developers, The Trillion brings a perfect mix of beautiful design, world-class amenities, and a prime location.",
        "The project offers spacious 3 BHK, 4 BHK apartments, and penthouses with smart layouts and premium interiors. Every home at rohan Trillion is made to give you more space, natural light, and a peaceful environment. High-quality materials, smart home features, and luxury fittings make each apartment truly special.",
        "Living at rohan Trillion Sector 48 Gurgaon means enjoying a lot of premium facilities. There is a modern clubhouse, swimming pool, gym, spa, private dining spaces, children’s play area, and beautiful green gardens. You also get 24x7 security, concierge services, and easy access to all daily needs.",
        "The location of rohan The Trillion is one of its biggest advantages. It is close to important offices, schools, hospitals, malls, and restaurants. Major roads like Golf Course Road, NH-8, and the Rapid Metro are nearby, making travel quick and easy.",
      ],
      keywordLinks: {
        "rohan": "/developers/rohan",
      },
      image: overviewImageprojectseven,
      buttonLabel: "Enquire Now",
      stripdata: [
        {
          iconClass: locationiconprojectseven,
          title: "₹ 6.14 Crore Onwards ",
          subtitle: "Starting Price",
        },
        {
          iconClass: caliconprojectseven,
          title: "20:40:40",
          subtitle: "Payment Plan",
        },
        {
          iconClass: newlaunchiconprojectseven,
          title: "New Launch ",
          subtitle: "Status",
        },
      ],
    },

    pricing: {
      heading: "Pricing",
      table: [
        {
          type: "3 BHK ",
          area: "3000 sq.ft.",
          price: "₹ 6.14 Cr",
          eoiAmount: "On Request",
        },
        {
          type: "4 BHK  ",
          area: "3600 sq.ft. ",
          price: "₹ 7.37 Cr",
          eoiAmount: "On Request",
        },
      ],
    },

    floor_plan: [
      {
        type: "3 BHK ",
        area: "3000 sq.ft.",
        price: "₹ 6.14 Cr",
        image: floorplan1projectseven,
      },
      {
        type: "4 BHK  ",
        area: "3600 sq.ft. ",
        price: "₹ 7.37 Cr",
        image: floorplan2projectseven,
      }
    ],

    highlights: {
      images: Hightlightsprojectseven,
      tagline: "Highlights",
      features: [
        "540 EXCLUSIVE Units. ",
        "Over 80% of green space. ",
        "Stilt + 45 Storey Towers. ",
        "VRV / VRF Air-Conditioning & Modular Kitche. ",
        "Basement Entrance Lobby with Green Atrium. ",
        "Two Car Parkings Per Unit. ",
        "Over 1 lakh sq. ft. of amenities space. ",
      ],
    },

    location: {
      image: Locationprojectseven,
      data: [
        {
          airport: {
            distance_time: "24 km",
            name: "IGI Airport"
          },
          school: {
            distance_time: "1 Km",
            name: "GD Goenka School"
          },
          railwayormetro: {
            distance_time: "6 Km",
            name: "Millennium City Centre Gurugram"
          },
          hospital: {
            distance_time: "1 Km",
            name: "Park Hospital"
          },
          mall: {
            distance_time: "7 Km",
            name: "Airia Mall"
          }
        }
      ]
    },

    gallery: {
      color: "#cd8c66",
      tagline: "Project Gallery",
      images: [
        { image: gallery1projectseven },
        { image: gallery2projectseven },
        { image: gallery3projectseven },
        { image: gallery4projectseven },
        { image: gallery5projectseven },
      ],
    },

    whatsapp: {
      title: "Property Station",
      subTitle: "Happy to Help You!",
      greetingText: "Hi there! \nHow can I help you?",
      ctaText: "Start Chat",
      whatsAppNumber: "7079429676",
      welcomeMessage:
        "Hi! I'm interested in rohan The Trillion, kindly share more details.",
    },

    faq: [
      {
        question: "Where is rohan The Trillion located?",
        answer: `rohan The Trillion is located in Sector 48, Gurgaon, providing excellent connectivity to major business hubs and city landmarks.`,
      },
      {
        question: "What types of homes are available at rohan The Trillion?",
        answer: `rohan The Trillion offers spacious 3 BHK and 4 BHK luxury apartments designed for premium living.`,
      },
      {
        question: "What is the size range of apartments in rohan The Trillion?",
        answer: `The 3 BHK apartments are approximately 2850 sq. ft., and the 4 BHK apartments are around 3600 sq. ft.`,
      },
      {
        question: "What is the price range for apartments at rohan The Trillion?",
        answer: `Prices start from ₹6.14 Crores onwards, depending on the unit size, floor, and view.`,
      },
      {
        question: "Is the project RERA registered?",
        answer: `Yes, rohan The Trillion is RERA registered.`,
      },
      {
        question: "What is the possession status of rohan The Trillion?",
        answer: `The project is newly launched.`,
      },
      {
        question: "What amenities are offered at rohan The Trillion?",
        answer: `Amenities include a grand clubhouse, swimming pool, gym, spa, kids’ play area, jogging track, and landscaped gardens.`,
      },
      {
        question: "Who is the developer of rohan The Trillion?",
        answer: `rohan The Trillion is developed by rohan Developers, one of India's most trusted and reputed real estate developers, known for quality and innovation.`,
      },
      {
        question: "Is rohan The Trillion a good investment in Gurgaon?",
        answer: `Yes, with its prime location, luxury features, and strong brand reputation, rohan The Trillion is considered an excellent investment option in Gurgaon.`,
      },
      {
        question: "How is the connectivity from rohan The Trillion?",
        answer: `The project enjoys superb connectivity via Golf Course Extension Road and NH-8, offering easy access to major business centers and important city locations.`,
      }
    ],


    form_data: {
      api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
      api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
      source_id: 11,
      sub_source_id: 130,
      builder_id: `103`,
      project_id: `477`,
      subject: "Property Station enquiry", // Add or update the subject here
      to_email: "leads@gurugram-property.com",
    },
  },
  projecteight: {
    bannerdata: {
      bannerDesktopImage: bannerDesktopImageprojecteight,
      bannerMobileImage: bannerMobileImageprojecteight,
      textOverlay: "",
      data: {
        title: "rohan The Trillion",
        subtitle: " Sector 48, Gurugram",
        starting_price: "₹ 6.14 Crore Onwards  ",
        payment_plan: "20:40:40",
        rerano: "GGM/911/643/2025/14",
        status: "New Launch"
      }
    },

    overview: {
      heading: "rohan The Trillion",
      description: [
        "rohan The Trillion in Gurgaon is a new luxury residential project that offers a stylish and comfortable lifestyle. This residential project is located in Sector 48, Golf Course Extension Road, this project is designed for people who want a modern home with top-class features. It is developed by rohan Developers, The Trillion brings a perfect mix of beautiful design, world-class amenities, and a prime location.",
        "The project offers spacious 3 BHK, 4 BHK apartments, and penthouses with smart layouts and premium interiors. Every home at rohan Trillion is made to give you more space, natural light, and a peaceful environment. High-quality materials, smart home features, and luxury fittings make each apartment truly special.",
        "Living at rohan Trillion Sector 48 Gurgaon means enjoying a lot of premium facilities. There is a modern clubhouse, swimming pool, gym, spa, private dining spaces, children’s play area, and beautiful green gardens. You also get 24x7 security, concierge services, and easy access to all daily needs.",
        "The location of rohan The Trillion is one of its biggest advantages. It is close to important offices, schools, hospitals, malls, and restaurants. Major roads like Golf Course Road, NH-8, and the Rapid Metro are nearby, making travel quick and easy.",
      ],
      keywordLinks: {
        "rohan": "/developers/rohan",
      },
      image: overviewImageprojecteight,
      buttonLabel: "Enquire Now",
      stripdata: [
        {
          iconClass: locationiconprojecteight,
          title: "₹ 6.14 Crore Onwards ",
          subtitle: "Starting Price",
        },
        {
          iconClass: caliconprojecteight,
          title: "20:40:40",
          subtitle: "Payment Plan",
        },
        {
          iconClass: newlaunchiconprojecteight,
          title: "New Launch ",
          subtitle: "Status",
        },
      ],
    },

    pricing: {
      heading: "Pricing",
      table: [
        {
          type: "3 BHK ",
          area: "3000 sq.ft.",
          price: "₹ 6.14 Cr",
          eoiAmount: "On Request",
        },
        {
          type: "4 BHK  ",
          area: "3600 sq.ft. ",
          price: "₹ 7.37 Cr",
          eoiAmount: "On Request",
        },
      ],
    },

    floor_plan: [
      {
        type: "3 BHK ",
        area: "3000 sq.ft.",
        price: "₹ 6.14 Cr",
        image: floorplan1projecteight,
      },
      {
        type: "4 BHK  ",
        area: "3600 sq.ft. ",
        price: "₹ 7.37 Cr",
        image: floorplan2projecteight,
      }
    ],

    highlights: {
      images: Hightlightsprojecteight,
      tagline: "Highlights",
      features: [
        "540 EXCLUSIVE Units. ",
        "Over 80% of green space. ",
        "Stilt + 45 Storey Towers. ",
        "VRV / VRF Air-Conditioning & Modular Kitche. ",
        "Basement Entrance Lobby with Green Atrium. ",
        "Two Car Parkings Per Unit. ",
        "Over 1 lakh sq. ft. of amenities space. ",
      ],
    },

    location: {
      image: Locationprojecteight,
      data: [
        {
          airport: {
            distance_time: "24 km",
            name: "IGI Airport"
          },
          school: {
            distance_time: "1 Km",
            name: "GD Goenka School"
          },
          railwayormetro: {
            distance_time: "6 Km",
            name: "Millennium City Centre Gurugram"
          },
          hospital: {
            distance_time: "1 Km",
            name: "Park Hospital"
          },
          mall: {
            distance_time: "7 Km",
            name: "Airia Mall"
          }
        }
      ]
    },

    gallery: {
      color: "#cd8c66",
      tagline: "Project Gallery",
      images: [
        { image: gallery1projecteight },
        { image: gallery2projecteight },
        { image: gallery3projecteight },
        { image: gallery4projecteight },
        { image: gallery5projecteight },
      ],
    },

    whatsapp: {
      title: "Property Station",
      subTitle: "Happy to Help You!",
      greetingText: "Hi there! \nHow can I help you?",
      ctaText: "Start Chat",
      whatsAppNumber: "7079429676",
      welcomeMessage:
        "Hi! I'm interested in rohan The Trillion, kindly share more details.",
    },

    faq: [
      {
        question: "Where is rohan The Trillion located?",
        answer: `rohan The Trillion is located in Sector 48, Gurgaon, providing excellent connectivity to major business hubs and city landmarks.`,
      },
      {
        question: "What types of homes are available at rohan The Trillion?",
        answer: `rohan The Trillion offers spacious 3 BHK and 4 BHK luxury apartments designed for premium living.`,
      },
      {
        question: "What is the size range of apartments in rohan The Trillion?",
        answer: `The 3 BHK apartments are approximately 2850 sq. ft., and the 4 BHK apartments are around 3600 sq. ft.`,
      },
      {
        question: "What is the price range for apartments at rohan The Trillion?",
        answer: `Prices start from ₹6.14 Crores onwards, depending on the unit size, floor, and view.`,
      },
      {
        question: "Is the project RERA registered?",
        answer: `Yes, rohan The Trillion is RERA registered.`,
      },
      {
        question: "What is the possession status of rohan The Trillion?",
        answer: `The project is newly launched.`,
      },
      {
        question: "What amenities are offered at rohan The Trillion?",
        answer: `Amenities include a grand clubhouse, swimming pool, gym, spa, kids’ play area, jogging track, and landscaped gardens.`,
      },
      {
        question: "Who is the developer of rohan The Trillion?",
        answer: `rohan The Trillion is developed by rohan Developers, one of India's most trusted and reputed real estate developers, known for quality and innovation.`,
      },
      {
        question: "Is rohan The Trillion a good investment in Gurgaon?",
        answer: `Yes, with its prime location, luxury features, and strong brand reputation, rohan The Trillion is considered an excellent investment option in Gurgaon.`,
      },
      {
        question: "How is the connectivity from rohan The Trillion?",
        answer: `The project enjoys superb connectivity via Golf Course Extension Road and NH-8, offering easy access to major business centers and important city locations.`,
      }
    ],


    form_data: {
      api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
      api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
      source_id: 11,
      sub_source_id: 130,
      builder_id: `103`,
      project_id: `477`,
      subject: "Property Station enquiry", // Add or update the subject here
      to_email: "leads@gurugram-property.com",
    },
  },
  projectnine: {
    bannerdata: {
      bannerDesktopImage: bannerDesktopImageprojectnine,
      bannerMobileImage: bannerMobileImageprojectnine,
      textOverlay: "",
      data: {
        title: "rohan The Trillion",
        subtitle: " Sector 48, Gurugram",
        starting_price: "₹ 6.14 Crore Onwards  ",
        payment_plan: "20:40:40",
        rerano: "GGM/911/643/2025/14",
        status: "New Launch"
      }
    },

    overview: {
      heading: "rohan The Trillion",
      description: [
        "rohan The Trillion in Gurgaon is a new luxury residential project that offers a stylish and comfortable lifestyle. This residential project is located in Sector 48, Golf Course Extension Road, this project is designed for people who want a modern home with top-class features. It is developed by rohan Developers, The Trillion brings a perfect mix of beautiful design, world-class amenities, and a prime location.",
        "The project offers spacious 3 BHK, 4 BHK apartments, and penthouses with smart layouts and premium interiors. Every home at rohan Trillion is made to give you more space, natural light, and a peaceful environment. High-quality materials, smart home features, and luxury fittings make each apartment truly special.",
        "Living at rohan Trillion Sector 48 Gurgaon means enjoying a lot of premium facilities. There is a modern clubhouse, swimming pool, gym, spa, private dining spaces, children’s play area, and beautiful green gardens. You also get 24x7 security, concierge services, and easy access to all daily needs.",
        "The location of rohan The Trillion is one of its biggest advantages. It is close to important offices, schools, hospitals, malls, and restaurants. Major roads like Golf Course Road, NH-8, and the Rapid Metro are nearby, making travel quick and easy.",
      ],
      keywordLinks: {
        "rohan": "/developers/rohan",
      },
      image: overviewImageprojectnine,
      buttonLabel: "Enquire Now",
      stripdata: [
        {
          iconClass: locationiconprojectnine,
          title: "₹ 6.14 Crore Onwards ",
          subtitle: "Starting Price",
        },
        {
          iconClass: caliconprojectnine,
          title: "20:40:40",
          subtitle: "Payment Plan",
        },
        {
          iconClass: newlaunchiconprojectnine,
          title: "New Launch ",
          subtitle: "Status",
        },
      ],
    },

    pricing: {
      heading: "Pricing",
      table: [
        {
          type: "3 BHK ",
          area: "3000 sq.ft.",
          price: "₹ 6.14 Cr",
          eoiAmount: "On Request",
        },
        {
          type: "4 BHK  ",
          area: "3600 sq.ft. ",
          price: "₹ 7.37 Cr",
          eoiAmount: "On Request",
        },
      ],
    },

    floor_plan: [
      {
        type: "3 BHK ",
        area: "3000 sq.ft.",
        price: "₹ 6.14 Cr",
        image: floorplan1projectnine,
      },
      {
        type: "4 BHK  ",
        area: "3600 sq.ft. ",
        price: "₹ 7.37 Cr",
        image: floorplan2projectnine,
      }
    ],

    highlights: {
      images: Hightlightsprojectnine,
      tagline: "Highlights",
      features: [
        "540 EXCLUSIVE Units. ",
        "Over 80% of green space. ",
        "Stilt + 45 Storey Towers. ",
        "VRV / VRF Air-Conditioning & Modular Kitche. ",
        "Basement Entrance Lobby with Green Atrium. ",
        "Two Car Parkings Per Unit. ",
        "Over 1 lakh sq. ft. of amenities space. ",
      ],
    },

    location: {
      image: Locationprojectnine,
      data: [
        {
          airport: {
            distance_time: "24 km",
            name: "IGI Airport"
          },
          school: {
            distance_time: "1 Km",
            name: "GD Goenka School"
          },
          railwayormetro: {
            distance_time: "6 Km",
            name: "Millennium City Centre Gurugram"
          },
          hospital: {
            distance_time: "1 Km",
            name: "Park Hospital"
          },
          mall: {
            distance_time: "7 Km",
            name: "Airia Mall"
          }
        }
      ]
    },

    gallery: {
      color: "#cd8c66",
      tagline: "Project Gallery",
      images: [
        { image: gallery1projectnine },
        { image: gallery2projectnine },
        { image: gallery3projectnine },
        { image: gallery4projectnine },
        { image: gallery5projectnine },
      ],
    },

    whatsapp: {
      title: "Property Station",
      subTitle: "Happy to Help You!",
      greetingText: "Hi there! \nHow can I help you?",
      ctaText: "Start Chat",
      whatsAppNumber: "7079429676",
      welcomeMessage:
        "Hi! I'm interested in rohan The Trillion, kindly share more details.",
    },

    faq: [
      {
        question: "Where is rohan The Trillion located?",
        answer: `rohan The Trillion is located in Sector 48, Gurgaon, providing excellent connectivity to major business hubs and city landmarks.`,
      },
      {
        question: "What types of homes are available at rohan The Trillion?",
        answer: `rohan The Trillion offers spacious 3 BHK and 4 BHK luxury apartments designed for premium living.`,
      },
      {
        question: "What is the size range of apartments in rohan The Trillion?",
        answer: `The 3 BHK apartments are approximately 2850 sq. ft., and the 4 BHK apartments are around 3600 sq. ft.`,
      },
      {
        question: "What is the price range for apartments at rohan The Trillion?",
        answer: `Prices start from ₹6.14 Crores onwards, depending on the unit size, floor, and view.`,
      },
      {
        question: "Is the project RERA registered?",
        answer: `Yes, rohan The Trillion is RERA registered.`,
      },
      {
        question: "What is the possession status of rohan The Trillion?",
        answer: `The project is newly launched.`,
      },
      {
        question: "What amenities are offered at rohan The Trillion?",
        answer: `Amenities include a grand clubhouse, swimming pool, gym, spa, kids’ play area, jogging track, and landscaped gardens.`,
      },
      {
        question: "Who is the developer of rohan The Trillion?",
        answer: `rohan The Trillion is developed by rohan Developers, one of India's most trusted and reputed real estate developers, known for quality and innovation.`,
      },
      {
        question: "Is rohan The Trillion a good investment in Gurgaon?",
        answer: `Yes, with its prime location, luxury features, and strong brand reputation, rohan The Trillion is considered an excellent investment option in Gurgaon.`,
      },
      {
        question: "How is the connectivity from rohan The Trillion?",
        answer: `The project enjoys superb connectivity via Golf Course Extension Road and NH-8, offering easy access to major business centers and important city locations.`,
      }
    ],


    form_data: {
      api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
      api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
      source_id: 11,
      sub_source_id: 130,
      builder_id: `103`,
      project_id: `477`,
      subject: "Property Station enquiry", // Add or update the subject here
      to_email: "leads@gurugram-property.com",
    },
  },
  projectten: {
    bannerdata: {
      bannerDesktopImage: bannerDesktopImageprojectten,
      bannerMobileImage: bannerMobileImageprojectten,
      textOverlay: "",
      data: {
        title: "rohan The Trillion",
        subtitle: " Sector 48, Gurugram",
        starting_price: "₹ 6.14 Crore Onwards  ",
        payment_plan: "20:40:40",
        rerano: "GGM/911/643/2025/14",
        status: "New Launch"
      }
    },

    overview: {
      heading: "rohan The Trillion",
      description: [
        "rohan The Trillion in Gurgaon is a new luxury residential project that offers a stylish and comfortable lifestyle. This residential project is located in Sector 48, Golf Course Extension Road, this project is designed for people who want a modern home with top-class features. It is developed by rohan Developers, The Trillion brings a perfect mix of beautiful design, world-class amenities, and a prime location.",
        "The project offers spacious 3 BHK, 4 BHK apartments, and penthouses with smart layouts and premium interiors. Every home at rohan Trillion is made to give you more space, natural light, and a peaceful environment. High-quality materials, smart home features, and luxury fittings make each apartment truly special.",
        "Living at rohan Trillion Sector 48 Gurgaon means enjoying a lot of premium facilities. There is a modern clubhouse, swimming pool, gym, spa, private dining spaces, children’s play area, and beautiful green gardens. You also get 24x7 security, concierge services, and easy access to all daily needs.",
        "The location of rohan The Trillion is one of its biggest advantages. It is close to important offices, schools, hospitals, malls, and restaurants. Major roads like Golf Course Road, NH-8, and the Rapid Metro are nearby, making travel quick and easy.",
      ],
      keywordLinks: {
        "rohan": "/developers/rohan",
      },
      image: overviewImageprojectten,
      buttonLabel: "Enquire Now",
      stripdata: [
        {
          iconClass: locationiconprojectten,
          title: "₹ 6.14 Crore Onwards ",
          subtitle: "Starting Price",
        },
        {
          iconClass: caliconprojectten,
          title: "20:40:40",
          subtitle: "Payment Plan",
        },
        {
          iconClass: newlaunchiconprojectten,
          title: "New Launch ",
          subtitle: "Status",
        },
      ],
    },

    pricing: {
      heading: "Pricing",
      table: [
        {
          type: "3 BHK ",
          area: "3000 sq.ft.",
          price: "₹ 6.14 Cr",
          eoiAmount: "On Request",
        },
        {
          type: "4 BHK  ",
          area: "3600 sq.ft. ",
          price: "₹ 7.37 Cr",
          eoiAmount: "On Request",
        },
      ],
    },

    floor_plan: [
      {
        type: "3 BHK ",
        area: "3000 sq.ft.",
        price: "₹ 6.14 Cr",
        image: floorplan1projectten,
      },
      {
        type: "4 BHK  ",
        area: "3600 sq.ft. ",
        price: "₹ 7.37 Cr",
        image: floorplan2projectten,
      }
    ],

    highlights: {
      images: Hightlightsprojectten,
      tagline: "Highlights",
      features: [
        "540 EXCLUSIVE Units. ",
        "Over 80% of green space. ",
        "Stilt + 45 Storey Towers. ",
        "VRV / VRF Air-Conditioning & Modular Kitche. ",
        "Basement Entrance Lobby with Green Atrium. ",
        "Two Car Parkings Per Unit. ",
        "Over 1 lakh sq. ft. of amenities space. ",
      ],
    },

    location: {
      image: Locationprojectten,
      data: [
        {
          airport: {
            distance_time: "24 km",
            name: "IGI Airport"
          },
          school: {
            distance_time: "1 Km",
            name: "GD Goenka School"
          },
          railwayormetro: {
            distance_time: "6 Km",
            name: "Millennium City Centre Gurugram"
          },
          hospital: {
            distance_time: "1 Km",
            name: "Park Hospital"
          },
          mall: {
            distance_time: "7 Km",
            name: "Airia Mall"
          }
        }
      ]
    },

    gallery: {
      color: "#cd8c66",
      tagline: "Project Gallery",
      images: [
        { image: gallery1projectten },
        { image: gallery2projectten },
        { image: gallery3projectten },
        { image: gallery4projectten },
        { image: gallery5projectten },
      ],
    },

    whatsapp: {
      title: "Property Station",
      subTitle: "Happy to Help You!",
      greetingText: "Hi there! \nHow can I help you?",
      ctaText: "Start Chat",
      whatsAppNumber: "7079429676",
      welcomeMessage:
        "Hi! I'm interested in rohan The Trillion, kindly share more details.",
    },

    faq: [
      {
        question: "Where is rohan The Trillion located?",
        answer: `rohan The Trillion is located in Sector 48, Gurgaon, providing excellent connectivity to major business hubs and city landmarks.`,
      },
      {
        question: "What types of homes are available at rohan The Trillion?",
        answer: `rohan The Trillion offers spacious 3 BHK and 4 BHK luxury apartments designed for premium living.`,
      },
      {
        question: "What is the size range of apartments in rohan The Trillion?",
        answer: `The 3 BHK apartments are approximately 2850 sq. ft., and the 4 BHK apartments are around 3600 sq. ft.`,
      },
      {
        question: "What is the price range for apartments at rohan The Trillion?",
        answer: `Prices start from ₹6.14 Crores onwards, depending on the unit size, floor, and view.`,
      },
      {
        question: "Is the project RERA registered?",
        answer: `Yes, rohan The Trillion is RERA registered.`,
      },
      {
        question: "What is the possession status of rohan The Trillion?",
        answer: `The project is newly launched.`,
      },
      {
        question: "What amenities are offered at rohan The Trillion?",
        answer: `Amenities include a grand clubhouse, swimming pool, gym, spa, kids’ play area, jogging track, and landscaped gardens.`,
      },
      {
        question: "Who is the developer of rohan The Trillion?",
        answer: `rohan The Trillion is developed by rohan Developers, one of India's most trusted and reputed real estate developers, known for quality and innovation.`,
      },
      {
        question: "Is rohan The Trillion a good investment in Gurgaon?",
        answer: `Yes, with its prime location, luxury features, and strong brand reputation, rohan The Trillion is considered an excellent investment option in Gurgaon.`,
      },
      {
        question: "How is the connectivity from rohan The Trillion?",
        answer: `The project enjoys superb connectivity via Golf Course Extension Road and NH-8, offering easy access to major business centers and important city locations.`,
      }
    ],


    form_data: {
      api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
      api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
      source_id: 11,
      sub_source_id: 130,
      builder_id: `103`,
      project_id: `477`,
      subject: "Property Station enquiry", // Add or update the subject here
      to_email: "leads@gurugram-property.com",
    },
  },
};
